<template>
<div>


  <section class="content">

      <!-- Default box -->
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">Banks Accounts List</h3>
          <span class="float-right">
            <button type="button" class="btn btn-sm btn-success" @click="newModal">
              <i class="fa fa-plus"></i>
            </button>
          </span>

          <div class="box-tools pull-right">
            <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip" title="" data-original-title="Collapse">
              <i class="fa fa-minus"></i></button>
            <button type="button" class="btn btn-box-tool" data-widget="remove" data-toggle="tooltip" title="" data-original-title="Remove">
              <i class="fa fa-times"></i></button>
          </div>
        </div>
        <div class="box-body">
          
          <vue-good-table
                :columns="columns"
                :rows="rows"
                styleClass="vgt-table condensed"
                :pagination-options="{
                  enabled: true,
                  perPage: 10,
                  perPageDropdown: [10, 20, 30],
                }"
                :search-options="{
                  enabled: true,
                  trigger: 'enter',
                }"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'Branch'">
                    <span v-for="branch in branches" in :key="branch.id">
                        <span v-if="props.row.branch_id == branch.id">{{ branch.name }}</span>
                    </span>
                  </span>
                  <span v-if="props.column.field == 'Status'">
                    <span
                      v-if="props.row.status == 'active'"
                      class="label label-success"
                      >Active</span
                    >
                    <span v-else class="label label-danger">InActive</span>
                  </span>
                  <span v-if="props.column.field == 'AccountType'">
                    <span
                      v-if="props.row.accountType == 'saving'"
                      class="label label-success"
                      >Saving</span
                    >
                    <span v-else class="label label-danger">Current</span>
                  </span>
                  <span v-if="props.column.field == 'id'">
                    <button
                      type="button"
                      @click="viewModal(props.row)"
                      class="btn btn-info btn-xs"
                    >
                      <i class="fa fa-eye"></i>
                    </button>
                    <button
                      type="button"
                      @click="editModal(props.row)"
                      class="btn btn-success btn-xs"
                    >
                      <i class="fa fa-pencil"></i>
                    </button>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table>
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer">
          List of all Banks Accounts
        </div>
        <!-- /.box-footer-->
      </div>
      <!-- /.box -->

    </section>
      <div class="modal fade" id="newModal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Add New Bank Account</h4>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form
              @submit.prevent="
                editMode ? updateBankAccount() : createBankAccount()
              "
            >
              <div class="modal-body">
                <!-- right column -->
                <div class="col-md-12">
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <!-- text input -->
                          <div class="form-group">
                            <label>Bank Name<span class="red">*</span></label>
                            <select
                              v-model="form.bank_id"
                              name="bank_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('bank_id'),
                              }"
                            >
                              <option v-if="!form.bank_id" selected value="">
                                Select Bank
                              </option>
                              <option
                                :value="bank.id"
                                v-for="bank in banks"
                                :key="bank.id"
                              >
                                {{ bank.name }}
                              </option>
                            </select>
                            <has-error :form="form" field="bank_id"></has-error>
                          </div>

                          <div class="form-group">
                            <label
                              >Account Number <span class="red">*</span></label
                            >
                            <input
                              v-model="form.accountNo"
                              type="number"
                              name="accountNo"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('accountNo'),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="accountNo"
                            ></has-error>
                          </div>
                          <div class="form-group">
                            <label
                              >Account Type <span class="red">*</span></label
                            >
                            <select
                              v-model="form.accountType"
                              name="accountType"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('accountType'),
                              }"
                            >
                              <option
                                v-if="!form.accountType"
                                selected
                                value=""
                              >
                                Select Account Type
                              </option>
                              <option value="saving">Saving</option>
                              <option value="current">Current</option>
                            </select>
                            <has-error
                              :form="form"
                              field="accountType"
                            ></has-error>
                          </div>

                          <div class="form-group">
                            <label>IFSC Code</label>
                            <input
                              v-model="form.ifsc"
                              type="text"
                              name="ifsc"
                              class="form-control"
                              :class="{ 'is-invalid': form.errors.has('ifsc') }"
                            />
                            <has-error :form="form" field="ifsc"></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Address</label>
                            <input
                              v-model="form.address"
                              type="text"
                              name="address"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('address'),
                              }"
                            />
                            <has-error :form="form" field="address"></has-error>
                          </div>
                          <div class="form-group">
                            <label
                              >Opening Date <span class="red">*</span></label
                            >
                            <input
                              v-model="form.accountOpeningDate"
                              type="date"
                              name="accountOpeningDate"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'accountOpeningDate'
                                ),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="accountOpeningDate"
                            ></has-error>
                          </div>

                          <div class="form-group">
                            <label
                              >Use for Printing
                              <span class="red">*</span></label
                            >

                            <div class="form-check">
                              <input
                                v-model="form.printing"
                                value="active"
                                id="customRadio5"
                                class="form-check-input"
                                :class="{
                                  'is-invalid': form.errors.has('printing'),
                                }"
                                type="radio"
                                name="printing"
                              />
                              <label class="form-check-label" for="customRadio5"
                                >Active</label
                              >
                              <has-error
                                :form="form"
                                field="printing"
                              ></has-error>
                            </div>
                            <div class="form-check">
                              <input
                                v-model="form.printing"
                                value="inActive"
                                id="customRadio6"
                                class="form-check-input"
                                :class="{
                                  'is-invalid': form.errors.has('printing'),
                                }"
                                type="radio"
                                name="printing"
                                checked
                              />
                              <label class="form-check-label" for="customRadio6"
                                >InActive</label
                              >
                              <has-error
                                :form="form"
                                field="printing"
                              ></has-error>
                            </div>
                          </div>
                          <div class="form-group">
                            <label
                              >Account Status <span class="red">*</span></label
                            >

                            <div class="form-check">
                              <input
                                v-model="form.status"
                                value="active"
                                id="customRadio1"
                                class="form-check-input"
                                :class="{
                                  'is-invalid': form.errors.has('status'),
                                }"
                                type="radio"
                                name="status"
                              />
                              <label class="form-check-label" for="customRadio1"
                                >Active</label
                              >
                              <has-error
                                :form="form"
                                field="status"
                              ></has-error>
                            </div>
                            <div class="form-check">
                              <input
                                v-model="form.status"
                                value="inActive"
                                id="customRadio2"
                                class="form-check-input"
                                :class="{
                                  'is-invalid': form.errors.has('status'),
                                }"
                                type="radio"
                                name="status"
                              />
                              <label class="form-check-label" for="customRadio2"
                                >InActive</label
                              >
                              <has-error
                                :form="form"
                                field="status"
                              ></has-error>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <h2>Bank Link With</h2>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Company Branch</label>
                            <select
                              v-model="form.branch_id"
                              name="branch_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('branch_id'),
                              }"
                            >
                              <option v-if="!form.branch_id" selected value="">
                                Select Company Branch
                              </option>
                              <option
                                :value="branch.id"
                                v-for="branch in branches"
                                :key="branch.id"
                              >
                                {{ branch.name }}
                              </option>
                            </select>
                            <has-error
                              :form="form"
                              field="branch_id"
                            ></has-error>
                          </div>
                        </div>
                        <div class="col-md-6"></div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!--/.col (right) -->
              </div>
              <div class="modal-footer text-center">
                <button
                  v-show="!editMode"
                  type="submit"
                  class="btn btn-success"
                >
                  SAVE
                </button>
                <button v-show="editMode" type="submit" class="btn btn-success">
                  UPDATE
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->

      <div class="modal fade" id="viewModal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Bank Account Details</h4>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <!-- right column -->
              <div class="row">
                <div class="col-md-6">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                      <ul class="list-group list-group-unbordered mb-3">
                        <li class="list-group-item">
                          <b>Bank Name</b>
                          <a
                            class="float-right"
                            v-for="bank in banks"
                            :key="bank.id"
                          >
                            <span v-if="form.bank_id == bank.id">
                              {{ bank.name }}
                            </span>
                          </a>
                        </li>
                        <li class="list-group-item">
                          <b>Account Number</b>
                          <a class="float-right">{{ form.accountNo }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Account Type</b>
                          <a class="float-right">{{ form.accountType }}</a>
                        </li>
                        <li
                          class="list-group-item"
                          v-if="form.status == 'active'"
                        >
                          <b>Account Status</b>
                          <a class="float-right"
                            ><span class="badge badge-success">Active</span></a
                          >
                        </li>
                        <li class="list-group-item" v-else>
                          <b>Account Status</b>
                          <a class="float-right"
                            ><span class="badge badge-danger">InActive</span></a
                          >
                        </li>
                        <li class="list-group-item">
                          <b>Company Branch</b>
                          <a
                            class="float-right"
                            v-for="branch in branches"
                            :key="branch.id"
                          >
                            <span v-if="form.branch_id == branch.id">
                              {{ branch.name }}
                            </span>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                <div class="col-md-6">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                      <ul class="list-group list-group-unbordered mb-3">
                        <li class="list-group-item">
                          <b>Opening Date</b>
                          <a class="float-right">{{
                            form.accountOpeningDate
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>IFSC Code</b>
                          <a class="float-right">{{ form.ifsc }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Address</b>
                          <a class="float-right">{{ form.address }}</a>
                        </li>
                        <li
                          class="list-group-item"
                          v-if="form.printing == 'active'"
                        >
                          <b>Use For Printing</b>
                          <a class="float-right"
                            ><span class="badge badge-success">Yes</span></a
                          >
                        </li>
                        <li class="list-group-item" v-else>
                          <b>Use For Printing</b>
                          <a class="float-right"
                            ><span class="badge badge-danger">No</span></a
                          >
                        </li>
                      </ul>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-primary"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      

</div>
</template>

<script>
export default {
  name: 'BankAccounts',
  data () {
    return {
      banks: {},
      branches: {},
      editMode: false,
      form: new Form({
        id: '',
        bank_id: '',
        accountNo: '',
        accountType: '',
        status: '',
        accountOpeningDate: '',
        ifsc: '',
        address: '',
        printing: '',
        branch_id: ''
      }),
      columns: [
        {
          label: 'BANK NAME',
          field: 'bank.name'
        },
        {
          label: 'ACCOUNT TYPE',
          field: 'AccountType'
        },
        {
          label: 'A/c No.',
          field: 'accountNo'
        },
        {
          label: 'IFSC',
          field: 'ifsc'
        },
        {
          label: 'BRANCH',
          field: 'Branch'
        },
        {
          label: 'STATUS',
          field: 'Status'
        },
        {
          label: 'ACTIONS',
          field: 'id',
          type: 'number'
        }
      ],
      rows: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    viewModal (row) {
      this.editMode = false
      this.form.reset()
      $('#viewModal').modal('show')
      this.form.fill(row)
    },
    newModal () {
      this.editMode = false
      this.form.reset()
      $('#newModal').modal('show')
    },
    createBankAccount () {
      this.$axios
        .post('bankaccount', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Bank Account Added Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    editModal (row) {
      this.editMode = true
      this.form.reset()
      $('#newModal').modal('show')
      this.form.fill(row)
    },
    updateBankAccount () {
      this.$axios
        .put('bankaccount/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Bank Account Details Updated Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadData () {
      let loader = this.$loading.show()
      this.$axios
        .get('bankaccount?all=all', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          this.rows = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadBank () {
      this.$axios
        .get('bank?all=all', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.banks = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadBranch () {
      this.$axios
        .get('branch?all=all', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.branches = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  created () {
    this.loadData()
    this.loadBank()
    this.loadBranch()
    Fire.$on('AfterCreate', () => {
      this.loadData()
    })
  }
}
</script>



// WEBPACK FOOTER //
// BankAccounts.vue?2d437369